import { render, staticRenderFns } from "./SwipeCountData.vue?vue&type=template&id=2333fd8f"
import script from "./SwipeCountData.vue?vue&type=script&lang=js"
export * from "./SwipeCountData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports